import './menu_button.less';
import { useEffect } from 'react';
import React         from 'react';


export default function MenuButton({ menuIsOpen, closeMenu, toggleMenu }) {

  useEffect(function toggleClass() {
    toggleMenuOpenClass(menuIsOpen);
  }, [ menuIsOpen ]);

  useEffect(function listenForEvents() {
    function clickListener(event) {
      const { target }           = event;
      const menuPanel            = document.querySelector('.menu-panel');
      const menuButton           = document.querySelector('.menu-button');
      const clickedOutsidePanel  = !menuPanel.contains(target);
      const clickedOutsideButton = !menuButton.contains(target);
      if (clickedOutsidePanel && clickedOutsideButton)
        closeMenu();
    }

    function keyListener(event) {
      const { key }  = event;
      const isEscape = (key === 'Escape');
      if (isEscape)
        closeMenu();
    }

    function addListeners() {
      document.body.addEventListener('click', clickListener);
      document.body.addEventListener('keydown', keyListener);
    }

    function removeListeners() {
      document.body.removeEventListener('click', clickListener);
      document.body.removeEventListener('keydown', keyListener);
    }

    if (menuIsOpen)
      addListeners();
    else
      removeListeners();

    return removeListeners;
  }, [ menuIsOpen, closeMenu ]);

  return (
    <div className="menu-button" onClick={toggleMenu}>
      <div className="menu-icon"/>
    </div>
  );
}

function toggleMenuOpenClass(menuOpen) {
  document.documentElement.classList.toggle('menu-open', menuOpen);
}
